module.exports = __webpack_public_path__ + "static/portfolio-1-d6efd70ccb4dd9948c78ef8c172fc396.jpg";